import type { zh } from './locales/zh'

export const LOCALES = ['zh', 'en', 'ja'] as const
export type Locale = (typeof LOCALES)[number]

/** 中文是源语言，键集合以它为准。 */
export type MessageKey = keyof typeof zh

/**
 * en / ja 的词典都标成这个类型：少一个键、多一个键都是**编译错误**，
 * 而不是运行时悄悄回退到中文。翻译漏了要在 `tsc -b` 就发现，
 * 而不是等用户截图过来。
 */
export type Messages = Record<MessageKey, string>

/** 复数：有 `.other` 的键就能用 plural() 取，类型上只允许这些前缀。 */
export type PluralKey = {
  [K in MessageKey]: K extends `${infer Base}.other` ? Base : never
}[MessageKey]

export type Params = Record<string, string | number>

/** 各语言自己的 BCP 47 标签，给 Intl 与 <html lang> 用 */
export const BCP47: Record<Locale, string> = {
  zh: 'zh-CN',
  en: 'en',
  ja: 'ja',
}

export const LOCALE_NAMES: Record<Locale, string> = {
  zh: '简体中文',
  en: 'English',
  ja: '日本語',
}
